import { BaseDataService } from './BaseDataService';
import { UserScore, User, SurveyVersion, SurveyInstance } from '../../models';
import { NotificationService } from '../../services';
import { OpenBlobFile } from '../../utilities';

export class UserScoreDataService extends BaseDataService<UserScore> {
    constructor(notificationService: NotificationService) {
        super('UserScore', 'UserScores', notificationService);
    }

    public getStructure(surveyVersion: SurveyVersion): Promise<UserScore[]> {
        const endpoint = `${this.endpointRoot}/structure/${surveyVersion.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    public getBySurveyVersion(userId: number, surveyVersion: SurveyVersion): Promise<UserScore[]> {
        const endpoint = `${this.endpointRoot}/${userId}/bysurveyversion/${surveyVersion.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    public getBySurveyInstance(user: User, surveyInstance: SurveyInstance, surveyVersionId?: number): Promise<UserScore[]> {
        var endpoint = `${this.endpointRoot}/${user.id}/bysurveyInstance/${surveyInstance.id}`;
        if (surveyVersionId) {
            endpoint = `${endpoint}/${surveyVersionId}`;
        }
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    public clear(surveyInstance: SurveyInstance, surveyVersionId?: number): Promise<UserScore[]> {
        var endpoint = `${this.endpointRoot}/clear/${surveyInstance.id}`;
        if (surveyVersionId) {
            endpoint = `${endpoint}/${surveyVersionId}`;
        }
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    public getBreakdown(user: User, surveyInstance: SurveyInstance, surveyVersionId?: number): Promise<any> {
        var endpoint = `${this.endpointRoot}/${user.id}/breakdown/${surveyInstance.id}`;
        if (surveyVersionId) {
            endpoint = `${endpoint}/${surveyVersionId}`;
        }
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    public getRawBreakdown(user: User, surveyInstance: SurveyInstance, surveyVersionId?: number): Promise<any> {
        var endpoint = `${this.endpointRoot}/${user.id}/rawbreakdown/${surveyInstance.id}`;
        if (surveyVersionId) {
            endpoint = `${endpoint}/${surveyVersionId}`;
        }
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Network response was not ok.');
        });
    }

    public save(user: User, surveyInstance: SurveyInstance, userScores: UserScore[]): Promise<any> {
        const endpoint = `${this.endpointRoot}/${user.id}/update/${surveyInstance.id}`;
        const init = this.buildRequestInit('POST', {
            userScores: userScores
        });

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                this.notificationService.addInfo('Saved user scores');
                return response.json();
            }
            const message = `Error retrieving saving user scores.`;
            this.notificationService.addError(message);
            throw new Error('Network response was not ok.');
        });
    }

    public export(user: User, surveyInstance: SurveyInstance, downloadName: string) {
        const endpoint = `${this.endpointRoot}/${user.id}/csv/${surveyInstance.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            // this returns a SurveyAssessmentViewModel
            if (response.ok) {
                return response.blob();
            }
            const message = `Error retrieving survey responses.`;
            this.notificationService.addError(message);
            throw new Error(message);
        }).then((blobData: any) => {
            return OpenBlobFile(blobData, downloadName + '.csv');
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/api/UserScoreData.tsx